import 'angular';
import '../../../../lib/assets/javascripts/devex/util';

angular.module('filters.formatDuration', [])
  .filter('formatDuration', function () {
    return function(duration, durationUnit) {
      if (durationUnit) {
        return duration + ' ' +
          devex.util.depluralizeUnit(duration, durationUnit);
      }
      return duration;

    };
  });
